module.exports = require("react-json-view");